import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { ToastrService } from 'ngx-toastr';
import { PasswordUpdateRequest } from '../_model/request/PasswordUpdateRequest';

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class PasswordUpdateComponent implements OnInit {

    passwordUpdateForm = this.formBuilder.group({
      password : ['', [Validators.required]],
      confirmPassword : ['', [Validators.required]]
      }, {validator: this.checkPasswords });
    passwordUpdateRequest: PasswordUpdateRequest = new PasswordUpdateRequest();
    passwordResetToken: string;
    constructor(private route: ActivatedRoute,
                private authService: AuthenticationService,
                private router: Router,
                private formBuilder: FormBuilder,
                private toastr: ToastrService) { }

    ngOnInit() {
        this.passwordResetToken = this.route.snapshot.params.token;

        // is token valid
        this.authService.isPasswordResetTokenValid(this.passwordResetToken).subscribe(response => {
           if (response.responseData.item === false) {
               // redirect to login
               this.router.navigate(['login']);
           }
        });
    }

    onSubmit() {
        this.passwordUpdateRequest.password = this.passwordUpdateForm.get('password').value;
        this.passwordUpdateRequest.passwordResetToken = this.passwordResetToken;
        this.authService.updatePassword(this.passwordUpdateRequest).subscribe(response => {
            this.toastr.success('Şifre güncellendi');
            setTimeout(() => {
                this.router.navigate(['login']);
            }, 2000);
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
        });
    }

    checkPasswords(group: FormGroup) { // here we have the 'passwords' group
        const password = group.get('password').value;
        const confirmPassword = group.get('confirmPassword').value;
        return password === confirmPassword ? null : { notSame: true };
    }
}
